import { Gaussian2D } from '../shapes/2d/gaussian2D/Gaussian2D';
/**
 * Generate a instance of a specific kind of shape.
 */
export function getShape2D(kind, shapeOptions = {}) {
    switch (kind) {
        case 'gaussian':
            return new Gaussian2D(shapeOptions);
        default: {
            const unHandled = kind;
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            throw Error(`Unknown distribution ${unHandled}`);
        }
    }
}
//# sourceMappingURL=getShape2D.js.map